/** Mirrors `validateSearch` for `/admin/menu` (see `routes/admin/menu.tsx`).
 *
 *  Menu Management kept its active tab in local state, so nothing on it could
 *  be linked to — the product form could not say "edit this item's recipe"
 *  and land anywhere. The tab now lives in the URL (F-FE-N157), and the
 *  costing drill-in with it, so `?tab=costing&item=<id>` opens the sheet. */
export type MenuTab = 'products' | 'categories' | 'variants' | 'deals' | 'costing' | 'catalog'

export const MENU_TABS: MenuTab[] = ['products', 'categories', 'variants', 'deals', 'costing', 'catalog']

export type MenuSearch = {
  tab?: MenuTab
  /** Product UUID — open its costing & recipe sheet on the Costing tab. */
  item?: string
}

/** Older wording for the same tab; an old link keeps landing somewhere. */
const TAB_ALIASES: Record<string, MenuTab> = {
  recipes: 'costing',
  recipe: 'costing',
  cost: 'costing',
  items: 'products',
  // The Modifiers tab became Variants (F-MOD-N12); old links still land.
  modifiers: 'variants',
  modifier: 'variants',
  options: 'variants',
  // F-DEAL-N1: combos, automatic discounts and upsells.
  combos: 'deals',
  combo: 'deals',
  offers: 'deals',
}

export function parseMenuSearch(raw: Record<string, unknown>): MenuSearch {
  const out: MenuSearch = {}
  const rawTab = typeof raw.tab === 'string' ? raw.tab.trim() : ''
  if (rawTab) {
    if ((MENU_TABS as string[]).includes(rawTab)) out.tab = rawTab as MenuTab
    else if (TAB_ALIASES[rawTab]) out.tab = TAB_ALIASES[rawTab]
  }
  const item = typeof raw.item === 'string' ? raw.item.trim() : ''
  if (item) {
    out.item = item
    // A costing drill-in implies the tab that hosts it, so a bare
    // `?item=<id>` link opens the sheet rather than the Products tab with an
    // invisible sheet behind it.
    if (!out.tab) out.tab = 'costing'
  }
  return out
}
